import { API_endpoints } from "../config";

export const updateFAQ = async (id: string, data: { question: string; answer: string; is_active: boolean }) => {
    try {
        const response = await fetch(API_endpoints.updateFAQs, {
            method: "POST", 
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ id, ...data }),  
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Aktualisieren der FAQ Anfrage");
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error("Fehler beim Aktualisieren der FAQ Anfrage:", error);
        throw error;
    }
};
